import React from 'react'
import { MovieSpecialIcon } from '@/atoms/Icons/MovieSpecialIcon'
import { SendTvIcon } from '@/atoms/Icons/SendTvIcon'
import { Display, HeadingLG, ParagraphLG } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'

export const WhyPif = () => {
  const { t } = useTranslate('pif')

  return (
    <div className="bg-black py-28">
      <div className="flex flex-col items-center px-8 text-center lg:px-32">
        <Display
          weight="bold"
          className="photon-heading-md sm:photon-heading-lg md:photon-heading-xl lg:photon-display pb-16"
        >
          {t('whyPayItForward', 'Why Pay it Forward?')}
        </Display>
        <div className="pb flex flex-col text-left xl:flex-row xl:space-x-12">
          <div className="mb-5 max-w-[466px] rounded-3xl bg-core-gray-900 p-10">
            <MovieSpecialIcon className="my-2" color="white" size={40} />
            <HeadingLG weight="bold" className="mb-2 text-[32px]">
              {t('helpFundFutureEpisodesAndSeasons', 'Help Fund Future Projects and Creators')}
            </HeadingLG>
            <ParagraphLG className="photon-paragraph-sm md:photon-paragraph-md lg:photon-paragraph-lg font-[375] text-core-gray-300">
              {t(
                'everyPiFContributionHelpsSupport',
                'Every Pay it Forward contribution helps support the directors, writers, animators, and other creators who bring stories to life, allowing them to continue making high-quality entertainment.',
              )}
            </ParagraphLG>
          </div>
          <div className="mb-5 max-w-[466px] rounded-3xl bg-core-gray-900 p-10">
            <SendTvIcon className="my-2" color="white" size={40} />
            <HeadingLG weight="bold" className="mb-2 text-[32px]">
              {t('makeMediaAccessibleAll', 'Make Media Accessible for All')}
            </HeadingLG>
            <ParagraphLG className="photon-paragraph-sm md:photon-paragraph-md lg:photon-paragraph-lg font-[375] text-core-gray-300">
              {t(
                'yourGenerosityHelpsUpliftingEntertainment',
                'Your generosity helps ensure that meaningful, uplifting entertainment is accessible to everyone, empowering audiences to enjoy wholesome stories and amplify light.',
              )}
            </ParagraphLG>
          </div>
        </div>
      </div>
    </div>
  )
}
